// Platform-managed API keys (Nitish, Oct 10 2026): today the Subagents key. It can be rotated, never revoked or renamed, and it
// shows on the API keys window AND Connectors > Keys. Same words as the backend's MANAGED_KEY_LINE (py/cellcog/model/api_key.py);
// py/cellcog/scripts/validate_subagents_key.py pins the two copies equal.
export const MANAGED_KEY_LINE = 'Created automatically for CellCog subagents. It can be rotated, not deleted.';

export const isManagedKey = (key) => Boolean(key && key.managed_by);

// CellCog Desktop keys (Desktop login v1, CEL-3612): one per connected computer. The owner can REMOVE one (that disconnects the
// computer), never rename or rotate it. Same words as the backend's desktop_key_line (py/cellcog/model/api_key.py);
// py/cellcog/scripts/validate_desktop_connect.py pins the two copies equal.
export const MANAGED_BY_DESKTOP = 'desktop';

export const isDesktopKey = (key) => Boolean(key && key.managed_by === MANAGED_BY_DESKTOP);

export const desktopKeyLine = (hostname) =>
  hostname
    ? `Created when you connected CellCog Desktop on ${hostname}. Remove it to disconnect that computer.`
    : 'Created when you connected CellCog Desktop. Remove it to disconnect that computer.';
